<template>
  <DefaultLayout
    :pageTitle="pageTitle"
    :pageDescription="pageDescription"
    :theme="theme"
  >
    <slot />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
  name: "FeaturePage",
  components: {
    DefaultLayout,
  },
  props: {
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
    theme: {
      type: String,
    },
  },
};
</script>
